import MarketPlace from './market-places/MarketPlace'
import WarehouseDetail from './warehouse/components/WarehouseDetails'
import Warehouse from './warehouse/Warehouse'
import Zone from './zone/Zone'
import WarehouseTransferRequest from '../../inventory/warehouseTransfer/WarehouseTransferRequest'
export const ROUTES = [
  {
    component: Zone,
    isProtected: true,
    showMenu: true,
    path: '/locations',
    slug: 'admin',
    title: 'admin',
    redirectTo: '/auth/login',
  },
  {
    component: Zone,
    isPublic: true,
    path: '/locations/zones',
    slug: 'zones',
    title: 'Zones',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: Warehouse,
    isPublic: true,
    path: '/locations/warehouses',
    slug: 'warehouses',
    title: 'Warehouses',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: MarketPlace,
    isPublic: true,
    path: '/locations/market-place',
    slug: 'marketplace',
    title: 'Marketplace',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: WarehouseDetail,
    isPublic: true,
    path: '/locations/warehouses/detail/:id',
    slug: 'warehouses',
    title: 'Warehouses',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
  {
    component: WarehouseTransferRequest,
    isPublic: true,
    path: '/locations/request',
    slug: 'inventory-request',
    title: 'Inventory Request',
    isProtected: true,
    showMenu: true,
    redirectTo: '/auth/login',
    isExact: true,
  },
]
